export const CouponApplicableType = {
  1: 'DEFAULT',
  2: 'STACKABLE',
  3: 'NOT_STACKABLE',
};
